const media = window.matchMedia('(max-width: 750px)');

function toggleMenuMobile(media) {
  if (media.matches) {
    // this toggles everytime i click anywhere on the page - consider refactor
    document.addEventListener(
      'click',
      function (event) {
        const nextMenuDisplay = event.target.nextElementSibling.style.display;

        if (!event.target.classList.contains('footer__menu--toggle-mobile')) return;

        if (!event.target.classList.contains('open')) {
          event.target.classList.add('open');
        } else {
          event.target.classList.remove('open');
        }

        if (nextMenuDisplay === 'block') {
          event.target.nextElementSibling.style.display = 'none';
        } else {
          event.target.nextElementSibling.style.display = 'block';
        }
      },
      false
    );
  } else {
    return;
  }
}

function toggleMenu() {
  // this toggles everytime i click anywhere on the page - consider refactor
  document.addEventListener(
    'click',
    function (event) {
      const nextMenuDisplay = event.target.nextElementSibling.style.display;

      if (!event.target.classList.contains('footer__menu--toggle')) return;

      if (!event.target.classList.contains('open')) {
        event.target.classList.add('open');
      } else {
        event.target.classList.remove('open');
      }

      if (nextMenuDisplay === 'block') {
        event.target.nextElementSibling.style.display = 'none';
      } else {
        event.target.nextElementSibling.style.display = 'block';
      }
    },
    false
  );
}

toggleMenuMobile(media);
toggleMenu();

media.addEventListener('change', function () {
  toggleMenuMobile(media);
});
